<template>
  <div ref="mapContainer" class="mc-liveview__map" :class="{ 'detail-panel-open': selectedDetail }">
    <LeafletTechnicianAddress ref="leaflet" />
    <button class="mc-map-toggle-sidebar" @click="toggleSideBar">
      <i class="mc-fa fas" :class="sidebarOpen ? 'fa-angle-right' : 'fa-angle-left'"></i>
    </button>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import LeafletTechnicianAddress from './LeafletTechnicianAddress';

export default {
  name: 'Map',

  components: { LeafletTechnicianAddress },

  computed: {
    sidebarOpen() {
      return this.$store.state.sidebar.sideBarOpen;
    },
    selectedDetail() {
      return this.$store.state.map.selectedTechnician;
    },
  },

  watch: {
    sidebarOpen() {
      this.$nextTick(() => {
        this.$refs.leaflet?.invalidateMap?.();
      });
    }
  },

  mounted() {
    const observer = new ResizeObserver(() => {
      this.$refs.leaflet?.invalidateMap?.();
    });
    observer.observe(this.$refs.mapContainer);
    this.$once('hook:beforeDestroy', () => observer.disconnect());
    this.$nextTick(() => {
        this.$refs.leaflet?.invalidateMap?.();
    });
  },

  methods: {
    ...mapMutations('sidebar', ['toggleSideBar']),
  },
};
</script>

<style scoped>
.mc-liveview__map {
  position: relative;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.mc-map-toggle-sidebar {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  width: 36px;
  height: 72px;
  background: white;
  border: 1px solid #dbe2ea;
  border-radius: 14px 0 0 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #64748b;
  transition: background 0.2s ease, color 0.2s ease;
}

.mc-map-toggle-sidebar:hover {
  background: #f8fafc;
  color: #0f172a;
}
</style>
